import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { RoleDto } from "@/core/features/roles/role.dto";
import { EmployeeDocumentCategoryTemplateDto } from "@/core/features/employee-document-categories/employee-document-category-template.dto";
import { EmployeeDocumentUploadModeEnum } from "@/core/features/employee-document-categories/employee-document-upload-mode.enum";
import { EmployeeDocumentBehaviorTypeEnum } from "@/core/features/employee-document-categories/employee-document-behavior-type.enum";
import { Type } from "class-transformer";

export class EmployeeDocumentCategoryDto extends BaseEntityDto {
  name: string;
  key?: string | null;
  isRequestedByDefault: boolean;
  isSystem: boolean;
  uploadMode: EmployeeDocumentUploadModeEnum;

  @Type(() => RoleDto)
  roles?: RoleDto[];

  @Type(() => EmployeeDocumentCategoryTemplateDto)
  template?: EmployeeDocumentCategoryTemplateDto | null;

  get roleIds(): string[] {
    return this.roles?.map((role) => role.id) ?? [];
  }

  get roleNames(): string {
    return this.roles?.map((role) => role.name).join(", ") || "Todos";
  }

  get hasActiveSignatureTemplate(): boolean {
    return Boolean(this.template?.isActive && this.template.latestVersion);
  }

  get behaviorType(): EmployeeDocumentBehaviorTypeEnum {
    return this.hasActiveSignatureTemplate
      ? EmployeeDocumentBehaviorTypeEnum.SIGNATURE
      : EmployeeDocumentBehaviorTypeEnum.UPLOAD;
  }

  get onboardingBehaviorLabel(): string {
    return this.hasActiveSignatureTemplate ? "Firma" : "Subida de archivo";
  }

  get uploadModeLabel(): string {
    return this.uploadMode === EmployeeDocumentUploadModeEnum.FRONT_AND_BACK_IMAGES
      ? "Anverso y reverso"
      : "Archivo único";
  }

  toString(): string {
    return this.name;
  }
}
